import React, {
  Component,
  PropTypes,
} from 'react'

import $ from 'jquery'
import {
  Row,
  Col,
  Icon,
} from 'antd'
// import Slider from 'react-slick'
import {
  EXTRA_SMALL_DEVICE, SMALL_DEVICE,
} from '../../constant'
import _cardExamProduct from '../cardExamProduct'
import _cardPackage from '../cardPackage'
// import _search from '../search'
// import _socialLink from '../socialLinks'
// import Owl from '../owl'
import { TextEllipsis } from '../../styled'

// import _pagination from '../../containers/Pagination'
import Banner from '../../containers/Banner'
import coinPic from '../../assets/coin_ver2_02.png'
// import SubBanner from '../../containers/SubBanner'
// import playerWhite from '../../assets/player_white.png'


import {
  encodeQueryUrl,
  decodeQueryUrl,
} from '../../utils'

function offset (el) {
  let rect = el.getBoundingClientRect()
  let scrollLeft = window.pageXOffset || document.documentElement.scrollLeft
  let scrollTop = window.pageYOffset || document.documentElement.scrollTop
  return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}
function checkTopScroll (topscroll) {
  let top = 0
  if (topscroll > 1000) {
    top = topscroll - 563
  } else {
    top = topscroll
  }
  return top
}
function phoneDevice (val) {
  let phone = false
  if (window.matchMedia('(max-width: 768px)').matches) {
    phone = true
  } else {
    phone = false
  }
  let toNode = document.getElementById('courseSection')
  let divEmail = offset(toNode)
  let top = checkTopScroll(divEmail.top)
  if (phone) {
    if (val === -1) {
      // setTimeout($('body,html').animate({ scrollTop: top + 463 }, 'slow'), 1000)
      setTimeout($('body,html').animate({ scrollTop: divEmail.top }, 'slow'), 1000)
    } else if (val === -2) {
      setTimeout($('body,html').animate({ scrollTop: divEmail.top - 663 }, 'slow'), 1000)
    } else if (val === -3) {
      setTimeout($('body,html').animate({ scrollTop: divEmail.top - 100 }, 'slow'), 1000)
    } else {
      setTimeout($('body,html').animate({ scrollTop: top - 100 }, 'slow'), 1000)
    }
    // setTimeout(window.scrollTo(0, divEmail.top + 300), 500)
  }
  // let length = 0
  // let lengthlevel2 = 288
  // if (item !== undefined) {
  //   if (i === 1) {
  //     length = Math.ceil(item.parent('ul').children('li.level1').length * 70)
  //   } else if (i === 2) {
  //     length = Math.ceil(item.children('li.level2').length * 80)
  //   } else {
  //     length = 288
  //   }
  // if (phone) {
  //   $('body,html').animate({
  //     scrollTop: 900,
  //   }, 'slow')
  // }
  // }
  // if (item === undefined) {
  //   if (phone) {
  //     $('body,html').animate({
  //       scrollTop: 1300,
  //     }, 'slow')
  //   }
  // }
}
function showAll (index) {
  let item = $(`#examProductPanel_${index}`)
  let length = 0
  if (window.matchMedia('(max-width: 768px)').matches) {
    length = Math.ceil(item.children('ul').children('li').length)
  } else {
    length = Math.ceil(item.children('ul').children('li').length / 3)
  }
  if ($('.examProductPanel').hasClass('show')) {
    $('.examProductPanel').removeClass('show')
    let indexExam = 0
    for (indexExam = 0; indexExam < document.getElementsByClassName('examProductPanel').length - 1; indexExam++) {
      if(parseFloat(document.getElementsByClassName('examProductPanel')[indexExam].style.height.split('px')[0]) >= '795px'){
      document.getElementsByClassName('examProductPanel')[indexExam].style.height = '795px'
      document.getElementsByClassName('examProductPanel')[indexExam].style.transition = 'linear .3s ease-in-out'
      }
    }
    // document.getElementsByClassName('examProductPanel')[0].style.height = '795px'
    // document.getElementsByClassName('examProductPanel')[0].style.transition = 'linear .3s ease-in-out'
    // document.getElementsByClassName('examProductPanel')[1].style.height = '795px'
    // document.getElementsByClassName('examProductPanel')[1].style.transition = 'linear .3s ease-in-out'
    // document.getElementsByClassName('examProductPanel')[2].style.height = '795px'
    // document.getElementsByClassName('examProductPanel')[2].style.transition = 'linear .3s ease-in-out'
    // document.getElementsByClassName('examProductPanel')[3].style.height = '580px'
    // document.getElementsByClassName('examProductPanel')[3].style.transition = 'linear .3s ease-in-out'
    item.addClass('show')
    // document.getElementById('').style.display = "block";
    document.getElementsByClassName('show')[0].style.height = `${length * 400}px`
    $('body,html').animate({
      scrollTop: item.offset().top - 150,
    }, 'slow')
  } else {
    item.addClass('show')
    document.getElementsByClassName('show')[0].style.height = `${length * 400}px`
    $('body,html').animate({
      scrollTop: item.offset().top - 150,
    }, 'slow')
  }
}

function changeClass () {
  $('.widget-navigation li button.parent, .widget-pages li>ul').parent().addClass('has-child')
}
function homeActive () {
  let item = $('.widget-navigation li.has-child.level1:nth-child(1)')
  item.removeClass('has-child')
}
function showChild (index) {
  let i = index + 2
  let item = $(`.widget-navigation li.has-child.level1:nth-child(${i})`)
  $('.widget-navigation li').removeClass('active_t')
  $('.widget-navigation li').removeClass('active_c')
  if ($('.widget-navigation li').hasClass('active')) {
    if (item.hasClass('active')) {
      item.children('ul.ul-child').slideUp(500)
      item.removeClass('active')
    } else {
      $('.widget-navigation li').children('ul.ul-child').slideUp(500)
      $('.widget-navigation li').removeClass('active')
      item.children('ul.ul-child').slideDown(500)
      item.addClass('active')
    }
  } else {
    item.children('ul.ul-child').slideDown(500)
    item.addClass('active')
  }
  changeClass()
}
// function showChildlevel (index) {
//   let i = index + 1
//   let item = $(`.widget-navigation li.has-child.level2:nth-child(${i})`)
//   $('.widget-navigation li.level2').removeClass('active_t')
//   $('.widget-navigation li').removeClass('active_c')
//   if ($('.widget-navigation li.level2').hasClass('active')) {
//     if (item.hasClass('active')) {
//       item.children('ul.ul-child-lv').slideUp(500)
//       item.removeClass('active')
//     } else {
//       $('.widget-navigation li.level2').children('ul.ul-child-lv').slideUp(500)
//       $('.widget-navigation li.level2').removeClass('active')
//       item.children('ul.ul-child-lv').slideDown(500)
//       item.addClass('active')
//     }
//   } else {
//     item.children('ul.ul-child-lv').slideDown(500)
//     item.addClass('active')
//   }
// }


class etestingHome extends Component {
  static propTypes = {
    pages: PropTypes.object.isRequired,
    params: PropTypes.string.isRequired,
    info: PropTypes.object.isRequired,
    categories: PropTypes.array.isRequired,
    newExam: PropTypes.array.isRequired,
    popularExam: PropTypes.array.isRequired,
    allExam: PropTypes.array.isRequired,
    listExam: PropTypes.array.isRequired,
    packages: PropTypes.array.isRequired,
    // onLoadMenu: PropTypes.func.isRequired,
    // onLoadPage: PropTypes.func.isRequired,
    onloadCategoryExam: PropTypes.func.isRequired,
    onloadListExam: PropTypes.func.isRequired,
  }
  componentWillMount () {
    // const {
    //   onloadCategoryExam,
    // } = this.props
    // onloadCategoryExam()
  }
  componentDidMount () {
    const {
      // onLoadPage,
      // onLoadMenu,
      // params,
      onloadCategoryExam,
    } = this.props
    // const { level, category, page } = decodeQueryUrl(params)
    // const isPage = !!page
    // const isLevel = !!level
    // const isCategory = !!category
    // onLoadPage({
    //   page: isPage ? isPage : 1,
    //   levelId: isLevel ? level : 0,
    //   categoryId: isCategory ? category : 0,
    // })
    // onLoadMenu()
    onloadCategoryExam()
  }
  componentWillReceiveProps= (nextProps) => {
    const {
      categories: oldProps,
      newExam: oldProps0,
      popularExam: oldProps1,
      allExam: oldProps2,
    } = this.props
    const {
      categories: newProps,
      newExam: newProps0,
      popularExam: newProps1,
      allExam: newProps2,
    } = nextProps
    if (oldProps !== newProps || oldProps0 !== newProps0 || oldProps1 !== newProps1 || oldProps2 !== newProps2) {
      changeClass()
      homeActive()
      if (window.matchMedia('(max-width: 768px)').matches) {
        this.phone = true
        // $('body,html').animate({
        //   scrollTop: 400,
        // }, 'slow')
      } else {
        this.phone = false
      }
    }
  }
  phone = false;
  status = true
  name = ''
  changeStatus () {
    phoneDevice()
    let item = $('.widget-navigation li:nth-child(1)')
    $('.widget-navigation li').removeClass('active_t')
    $('.widget-navigation li').removeClass('active')
    $('.widget-navigation li').children('ul.ul-child').slideUp(500)
    item.addClass('active_t')
    this.status = true
    const {
      onloadCategoryExam,
    } = this.props
    this.status = true
    onloadCategoryExam()
  }
  compare = (a, b) => {
    if (a.coin < b.coin) {
      return -1
    }
    if (a.coin > b.coin) {
      return 1
    }
    return 0
  }
  spendTime = (time) => {
    let second = (time / 1000)
    let minutes = second / 60
    second %= 60
    let hours = (minutes / 60)
    minutes %= 60

    let h = Math.floor(hours) === 0 ? '00' : `${Math.floor(hours)}`
    let m = Math.floor(minutes) === 0 ? '00' : `${Math.floor(minutes)}`
    let s = Math.ceil(second) === 0 ? '00' : `${Math.ceil(second)}`
    h = Math.floor(h) > 9 ? `${Math.floor(h)}` : `0${Math.floor(h)}`
    m = Math.floor(m) > 9 ? `${Math.floor(m)}` : `0${Math.floor(m)}`
    s = Math.floor(s) > 9 ? `${Math.floor(s)}` : `0${Math.floor(s)}`

    let t = [h, m, s]
    return t.join(':')
    // return <span> {Math.floor(hours) === 0 ? '00' : `${Math.floor(hours)} :` } {Math.floor(minutes) === 0 ? '00' : `${Math.floor(minutes)} :`} {Math.ceil(second) === 0 ? '00' : `${Math.ceil(second)} `}</span>
  }
  fetchObjectToQueryUrlAndRedirect = (objectSelect) => {
    const {
      params,
    } = this.props
    let queryUrlObj = decodeQueryUrl(params)
    return encodeQueryUrl({ ...queryUrlObj, ...objectSelect })
  }

  redirect = (queryUrl) => {
    window.location.href = `?${queryUrl}`
  }

  onchangeLevel = (e) => {
    const objLevel = {
      level: e.target.value,
    }
    const queryUrl = this.fetchObjectToQueryUrlAndRedirect(objLevel)
    this.redirect(queryUrl)
  }

  onchangeCategory = (e) => {
    const objCategory = {
      category: e.target.value,
    }
    const queryUrl = this.fetchObjectToQueryUrlAndRedirect(objCategory)
    this.redirect(queryUrl)
  }

  isCategory = () => {
    const {
      pages: {
        categories,
      },
      params,
    } = this.props
    const { category } = decodeQueryUrl(params)
    const selectCategory = categories.find(cat => cat._id === category)
    const isCategory = !!selectCategory
    return categories.length !== 0 && isCategory ? selectCategory.name : 'เลือกวิชา'
  }

  isLevel = () => {
    const {
      pages: {
        levels,
      },
      params,
    } = this.props
    const { level } = decodeQueryUrl(params)
    const selectLevel = levels.find(lv => lv._id === level)
    const isSelectLevel = !!selectLevel
    return levels.length !== 0 && isSelectLevel ? selectLevel.name : 'เลือกระดับชั้น'
  }

  selectedTopic = (sectionId, name, index, level, j) => {
    if (index !== -1) {
      let i = index + 2
      let item = $(`.widget-navigation li.level1.has-child:nth-child(${i})`)
      if (!item.hasClass('active')) {
        $('.widget-navigation li').removeClass('active_t')
        $('.widget-navigation li').removeClass('active')
        $('.widget-navigation li').removeClass('active_c')
        $('.widget-navigation li').children('ul.ul-child').slideUp(500)
        $('.widget-navigation li').children('ul.ul-child-lv').slideUp(500)
      }
      item.addClass('active_t')
      item.toggleClass('active')
      item.children('ul.ul-child').slideToggle(500)
      if (item.hasClass('active')) {
        phoneDevice(-1)
      } else {
        phoneDevice(-2)
      }
    } else {
      // phoneDevice(2, $('.widget-navigation li.level1.active ul.ul-child'))
      // if (level === 3) {
      //   let num = j
      //   let ele = $(`.widget-navigation li.level2.active ul.ul-child-lv>li:nth-child(${num})`)
      //   let parent = $('.widget-navigation li.level2.active ul.ul-child-lv>li')
      //   if (parent.hasClass('active_c')) {
      //     parent.removeClass('active_c')
      //     ele.addClass('active_c')
      //     phoneDevice(3, parent)
      //   } else {
      //     ele.addClass('active_c')
      //     phoneDevice(3, parent)
      //   }
      // }
      if (level === 2) {
        let num = j
        let ele = $(`.widget-navigation li.level1.active ul.ul-child>li.level2:nth-child(${num})`)
        let parent = $('.widget-navigation li.level1.active ul.ul-child>li.level2')
        if (parent.hasClass('active_c')) {
          parent.removeClass('active_c')
          parent.children('ul.ul-child-lv').slideUp(500)
          ele.addClass('active_c')
          phoneDevice(-3)
        } else {
          ele.addClass('active_c')
          phoneDevice(-3)
        }
      }
      if (level === 1) {
        let num = j + 1
        let parent = $('.widget-navigation li.level1.active ul.ul-child>li.level2')
        let ele = $(`.widget-navigation li.level1.active ul.ul-child>li.level2:nth-child(${num})`)
        if (parent.hasClass('active') && !ele.hasClass('active')) {
          parent.removeClass('active')
          parent.children('ul.ul-child-lv').children('li').removeClass('active_c')
          parent.children('ul.ul-child-lv').slideUp(500)
        }
        ele.toggleClass('active')
        // parent.children('ul.ul-child-lv').slideUp(500)
        ele.children('ul.ul-child-lv').slideToggle(500)
      }
    }
    // phoneDevice(2)
    this.name = name
    this.status = false
    this.needLoad = false
    const {
      onloadListExam,
    } = this.props
    onloadListExam(sectionId)
  }
  showPricebyTypeOfProduct = (examPrivate, coinPriceDate, id, typeOfProduct) => {
    const {
      info,
    } = this.props
    if (this.isInMylib(id, typeOfProduct)) {
      if(typeOfProduct === "exam") {
        return (<div className="containerPriceCoin" style={{ fontSize: '13px' }} ><div className="containerCoin" >เริ่มสอบ</div></div>)
      } else if(typeOfProduct === "course"){
        return (<div className="containerPriceCoin" style={{ fontSize: '13px' }} ><div className="containerCoin" >เริ่มเรียน</div></div>)
      } else {
        return (<div className="containerPriceCoin" style={{ fontSize: '13px' }} ><div className="containerCoin" >ซื้อแล้ว</div></div>)
      }
    } else if (examPrivate === 0 && coinPriceDate.length > 1) {
      return (<div className="containerPriceCoin" style={{ fontSize: '13px' }} ><div className="containerCoin" > {`${coinPriceDate.sort(this.compare)[0].coin} ~ ${coinPriceDate.sort(this.compare)[coinPriceDate.length - 1].coin}`} บาท</div>
      </div>)
    } else if (examPrivate === 0 && coinPriceDate.length === 1) {
      return (<div className="containerPriceCoin" style={{ fontSize: '13px' }}><div className="containerCoin" > {`${coinPriceDate[0].coin}`} บาท
      </div></div>)
    } else if (examPrivate === 1) {
      return (<div className="containerPriceCoin" style={{ fontSize: '13px' }}><div className="containerCoin" > ฟรี
      </div></div>)
    }
    return ''
  }
  isInMylib = (id, typeOfProduct) => {
    const {
      info,
    } = this.props
    if (typeOfProduct === "course"){
      return info.myLibCourse.filter( myCourse => myCourse.product !== null ? myCourse.product._id === id && myCourse.product.expDate >= Date.now() ? true : false : false).length > 0
    } else if (typeOfProduct === "exam"){
      return info.myLibExam.filter( myExam => myExam.product !== null ? myExam.product._id === id && myExam.product.expDate >= Date.now() ? true : false : false).length > 0
    }
    return info.myLibPackage.filter( myPackage => myPackage.product !== null ? myPackage.product._id  === id && myPackage.product.expDate >= Date.now()? true : false : false).length > 0
  }
  compare = (a, b) => {
    if (a.coin < b.coin) {
      return -1
    }
    if (a.coin > b.coin) {
      return 1
    }
    return 0
  }
  typeOfProduct = (product) => {
    if(product.exams !== undefined){
      return 'exam'
    } else if (product.courses !== undefined) {
      return 'course'
    }
    return 'package'
  }
  render () {
    const {
      // pages,
      // screen,
      categories,
      listExam,
      packages,
      // params,
      newExam,
      popularExam,
      allExam,
      info,
    } = this.props
    // const settings = {
    //   dots: true,
    //   infinite: true,
    //   speed: 600,
    //   slidesToShow: 3,
    //   slidesToScroll: 1,
    //   autoplay: false,
    //   arrows: false,
    //   adaptiveHeight: true,
    //   variableWidth: true,
    //   swipeToSlide: true,
    //   // adaptiveHeight: true,
    //   // className: 'slickWidth',
    //   responsive: [
    //     {
    //       breakpoint: 767,
    //       settings: {
    //         slidesToShow: 2,
    //         // slidesToScroll: 1,
    //         adaptiveHeight: true,
    //       },
    //     },
    //     {
    //       breakpoint: 375,
    //       settings: {
    //         slidesToShow: 2,
    //         // slidesToScroll: 1,
    //         adaptiveHeight: true,
    //       },
    //     },
    //   ],
    // }
    return (
      <div>
        <div className="page-content woocommerce">
          {screen === EXTRA_SMALL_DEVICE || screen === SMALL_DEVICE ?
            <Banner /> : ''
          }
          <div className="container clear-fix">
            <div className="columns-col columns-col-12 no-padding">
              {screen !== EXTRA_SMALL_DEVICE && screen !== SMALL_DEVICE ?
                <Banner /> : ''
              }
              <div className="columns-col columns-col-3" style={{ paddingTop: '15px' }}>
                <div className="widget-navigation responseNavigate" >
                  <ul>
                    <li className="active_t level1">
                      <button onClick={() => this.changeStatus()} style={{ width: '100%', height: '46px', lineHeight: '46px', paddingLeft: '21px', textAlign: 'left' }}>หน้าแรก</button>
                    </li>
                    {
                      categories.map((categoriesAll, index) => (
                        <li className={`level1 ${categoriesAll.categorys.length > 0 ? 'has-child' : ''} `} key={index}>
                          <button className="parent" onClick={() => showChild(index)} style={{ width: '40px', height: '46px', position: 'absolute', left: '81%' }} />
                          <button onClick={() => this.selectedTopic(categoriesAll._id, categoriesAll.name, index, 0)} style={{ width: '100%', height: '46px', lineHeight: '46px', paddingLeft: '21px', textAlign: 'left' }}>{categoriesAll.name}</button>
                          <ul className="ul-child">
                            {
                              // level.levels !== undefined && level.levels.length === 0 && level.categorys !== undefined ?
                              categoriesAll.categorys !== undefined ?
                              categoriesAll.categorys.map((catego, k) => (
                                  k !== 0 ?
                                    <li className="level2">
                                      <button onClick={() => this.selectedTopic(catego._id, catego.name, -1, 2, k)} style={{ width: '100%', height: '46px', lineHeight: '25px', paddingLeft: '42px', textAlign: 'left' }}>{catego.name}</button>
                                    </li>
                                  : ''
                                ))
                              : ''
                            }
                          </ul>
                        </li>
                      ))
                    }
                  </ul>
                </div>
                <br />
                {
                this.phone === false ?
                  <div className="fb-page"
                    data-href="https://www.facebook.com/deknerdclub/"
                    data-tabs="timeline,messages"
                    data-small-header="false"
                    data-adapt-container-width="true"
                    data-hide-cover="false"
                    data-show-facepile="true"
                  >
                    <blockquote cite="https://www.facebook.com/deknerdclub/"
                      className="fb-xfbml-parse-ignore"
                    >
                      <a href="https://www.facebook.com/deknerdclub/">DekNerd-เด็กเนิร์ด</a></blockquote></div>
                      :
                      ''
                }
              </div>
              <div className="columns-col columns-col-9" style={{ paddingTop: '15px' }}>
                {
                  this.status === true ?
                    <div id="courseSection">
                      {
                        this.phone === true ?
                          <div>
                            { packages.length > 0 ?
                            <div>
                            <div className="examProductHeader">
                              <h3>แพ็กเกจสุดคุ้ม</h3>
                              {/* <button className="seeAll" onClick={() => showAll(3)}>ดูทั้งหมด</button> */}
                            </div>
                            <hr />
                            <div className="course-container-Exam" >
                              <div className="limit-scroll-bar-Exam">
                                <div className="courses-scrollbar" style={{ width: packages.length * 323.55 }}>
                                  <div className="feature-courses">
                                    {
                                  packages.map(exam => (
                                    <div className="list-product-slide-package" >
                                      <div className="containerImg">
                                        <a href={`/packageDetail/${exam._id}`}>
                                          <img src={exam.promotional.imageURL_16_9} alt="" style={{ width: "auto", height: '182px' }}/>
                                        </a>
                                      </div>
                                      <div className="product-name custom-product-name-test">
                                        <a href={`/packageDetail/${exam._id}`}><TextEllipsis>{exam.productName}</TextEllipsis></a>
                                      </div>
                                      <div className="star-rating" title={`Rated ${exam.rating.avg} out of 5`} style={{ display: 'inline-flex', width: '80px' }}>
                                        <span style={{ width: `${exam.rating.avg * 20}%` }} /><div style={{ display: 'inline', fontSize: '12px' }}>({exam.rating.user})</div>
                                      </div>
                                      <span className="price">
                                        <span className="amount" style={{ lineHeight: '1.4' }}>
                                          {this.showPricebyTypeOfProduct(typeof exam.private !== 'undefined' ? exam.private : 0, exam.coinPriceDate, exam._id, this.typeOfProduct(exam))}
                                        </span>
                                      </span>
                                    </div>
                                ))
                              }
                                  </div>
                                </div>
                              </div>
                            </div>
                            <br />
                            </div>: ''
                            }
                            { newExam.length > 0 ?
                            <div>
                            <div className="examProductHeader">
                              <h3>ข้อสอบมาใหม่</h3>
                              {/* <button className="seeAll" onClick={() => showAll(3)}>ดูทั้งหมด</button> */}
                            </div>
                            <hr />
                            <div className="course-container-Exam" >
                              <div className="limit-scroll-bar-Exam">
                                <div className="courses-scrollbar" style={{ width: newExam.length * 187 }}>
                                  <div className="feature-courses">
                                    {
                                  newExam.map(exam => (
                                    <div className="list-product-slide" >
                                      <div className="containerImg">
                                        <a href={`/eTestingOverview/${exam._id}`}>
                                          <img src={exam.promotional.imageURL_1_1} alt="" />
                                        </a>
                                      </div>
                                      <div className="product-name custom-product-name-test">
                                        <a href={`/etestingOverview/${exam._id}`}><TextEllipsis>{exam.productName}</TextEllipsis></a>
                                      </div>
                                      <div style={{ lineHeight: '20px', fontSize: '12px' }}>
                                        <span>จำนวนคำถาม : {exam.exams.numQuestion}</span>
                                      </div>
                                      <div className="star-rating" title={`Rated ${exam.rating.avg} out of 5`} style={{ display: 'inline-flex', width: '80px' }}>
                                        <span style={{ width: `${exam.rating.avg * 20}%` }} /><div style={{ display: 'inline', fontSize: '12px' }}>({exam.rating.user})</div>
                                      </div>
                                      <span className="price">
                                        <span className="amount" style={{ lineHeight: '1.4' }}>
                                          {this.showPricebyTypeOfProduct(typeof exam.private !== 'undefined' ? exam.private : 0, exam.coinPriceDate, exam._id, this.typeOfProduct(exam))}
                                        </span>
                                      </span>
                                    </div>
                                ))
                              }
                                  </div>
                                </div>
                              </div>
                            </div>
                            <br />
                            </div>: ''
                            }
                            {/* <div className="examProductHeader">
                              <h3>คอร์สแนะนำ</h3>
                            </div>
                            <hr />
                            <div className="course-container" >
                              <div className="limit-scroll-bar">
                                <div className="courses-scrollbar" style={{ width: pages.coursesRecommended.length * 187 }}>
                                  <div className="feature-courses">
                                    {
                                  pages.coursesRecommended.map(course => (
                                    <div className="list-product-slide" >
                                      <div className="containerImg">
                                        <a href={`/course/${course._id}`}>
                                          <img src={course.promotional.imageURL_16_9} alt="" />
                                        </a>
                                        <div className="videoLength">
                                          <img src={playerWhite} alt="" style={{ width: '15px', height: '15px', margin: '4% 9%' }} />
                                          <span>{this.spendTime(course.courses.videoLength)}</span>
                                        </div>
                                      </div>
                                      <div className="product-name custom-product-name-test">
                                        <a href={`/course/${course._id}`}><TextEllipsis>{course.productName}</TextEllipsis></a>
                                        <span style={{ fontSize: '13px', color: '#b0b0b0' }} >{course.uploaders[0].displayName}</span>
                                      </div>
                                      <div className="star-rating" title={`Rated ${course.rating.avg} out of 5`} style={{ display: 'inline-flex' }}>
                                        <span style={{ width: `${course.rating.avg * 20}%` }} /><div style={{ display: 'inline', fontSize: '12px' }}>({course.rating.user})</div>
                                      </div>
                                      {
                                        course.coin === 0 ?
                                          <span className="price">
                                            <span className="amount">
                                              ฟรี
                                            </span>
                                          </span> :
                                          <span className="price">
                                            <span className="amount">
                                              {course.coin}<sup>฿</sup>
                                            </span>
                                          </span>
                                      }
                                    </div>
                                ))
                              }
                                  </div>
                                </div>
                              </div>
                            </div>
                            <br /> */}
                            { popularExam.length > 0 ?
                            <div>
                            <div className="examProductHeader">
                              <h3>ข้อสอบยอดนิยม</h3>
                              {/* <button className="seeAll" onClick={() => showAll(3)}>ดูทั้งหมด</button> */}
                            </div>
                            <hr />
                            <div className="course-container-Exam" >
                              <div className="limit-scroll-bar-Exam">
                                <div className="courses-scrollbar" style={{ width: popularExam.length * 187 }}>
                                  { /* <ul className="feature-courses">
                                    <li className="courses-item">
                                      <span>test course box</span>
                                    </li>
                                  </ul> */ }
                                  <div className="feature-courses">
                                    {
                                  popularExam.map(exam => (
                                    <div className="list-product-slide" >
                                      <div className="containerImg">
                                        <a href={`/eTestingOverview/${exam._id}`}>
                                          <img src={exam.promotional.imageURL_1_1} alt="" />
                                        </a>
                                      </div>
                                      <div className="product-name custom-product-name-test">
                                        <a href={`/eTestingOverview/${exam._id}`}><TextEllipsis>{exam.productName}</TextEllipsis></a>
                                      </div>
                                      <div style={{ lineHeight: '20px', fontSize: '12px' }}>
                                        <span>จำนวนคำถาม : {exam.exams.numQuestion}</span>
                                      </div>
                                      <div className="star-rating" title={`Rated ${exam.rating.avg} out of 5`} style={{ display: 'inline-flex', width: '80px' }}>
                                        <span style={{ width: `${exam.rating.avg * 20}%` }} /><div style={{ display: 'inline', fontSize: '12px' }}>({exam.rating.user})</div>
                                      </div>
                                      <span className="price">
                                        <span className="amount" style={{ lineHeight: '1.4' }}>
                                          {this.showPricebyTypeOfProduct(typeof exam.private !== 'undefined' ? exam.private : 0, exam.coinPriceDate, exam._id, this.typeOfProduct(exam))}
                                        </span>
                                      </span>
                                    </div>
                                ))
                              }
                                  </div>
                                </div>
                              </div>
                            </div>
                            <br />
                            </div> : ''
                            }
                            {allExam.length > 0 ?
                            <div>
                              <div className="examProductHeader">
                                <h3>ข้อสอบทั้งหมด</h3>
                                { /* <button className="seeAll" onClick={() => showAll(3)}>ดูทั้งหมด</button> */ }
                              </div>
                              <hr />
                              <div className="course-container-Exam" >
                                <div className="limit-scroll-bar-Exam">
                                  <div className="courses-scrollbar" style={{ width: allExam.length * 187 }}>
                                    { /* <ul className="feature-courses">
                                      <li className="courses-item">
                                        <span>test course box</span>
                                      </li>
                                    </ul> */ }
                                    <div className="feature-courses">
                                      {
                                    allExam.map(exam => (
                                      <div className="list-product-slide" >
                                        <div className="containerImg">
                                          <a href={`/eTestingOverview/${exam._id}`}>
                                            <img src={exam.promotional.imageURL_1_1} alt="" />
                                          </a>
                                        </div>
                                        <div className="product-name custom-product-name-test">
                                          <a href={`/eTestingOverview/${exam._id}`}><TextEllipsis>{exam.productName}</TextEllipsis></a>
                                        </div>
                                        <div style={{ lineHeight: '20px', fontSize: '12px' }}>
                                          <span>จำนวนคำถาม : {exam.exams.numQuestion}</span>
                                        </div>
                                        <div className="star-rating" title={`Rated ${exam.rating.avg} out of 5`} style={{ display: 'inline-flex', width: '80px' }}>
                                          <span style={{ width: `${exam.rating.avg * 20}%` }} /><div style={{ display: 'inline', fontSize: '12px' }}>({exam.rating.user})</div>
                                        </div>
                                        <span className="price">
                                          <span className="amount" style={{ lineHeight: '1.4' }}>
                                            {this.showPricebyTypeOfProduct(typeof exam.private !== 'undefined' ? exam.private : 0, exam.coinPriceDate, exam._id, this.typeOfProduct(exam))}
                                          </span>
                                        </span>
                                      </div>
                                  ))
                                }
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>: ''
                            }
                          </div>
                        :
                          <div>
                            { packages.length !== 0 ?
                            <div>
                              <Row gutter={32} justify="space-around">
                                <Col span={12}>
                                  <h3>แพ็กเกจสุดคุ้ม</h3>
                                </Col>
                                <Col span={12}>
                                  <button className="seeAll" onClick={() => showAll(1)}>ดูทั้งหมด</button>
                                </Col>
                              </Row>
                              <hr />
                              <div id="examProductPanel_1" className="examProductPanel" style={{ height: packages.length < 4 ? '397.5px' : '795px' }}>
                                <ul className="products">
                                  {
                                    packages.length !== 0 ?
                                    packages.map((exam, index) => (
                                      <_cardPackage
                                        key={index}
                                        imgURL={exam.promotional.imageURL_1_1}
                                        productName={exam.productName}
                                        coin={exam.coinPriceDate ? exam.coinPriceDate : []}
                                        // numQuestion={exam.exams.numQuestion}
                                        rating={exam.rating.avg}
                                        userrating={exam.rating.user}
                                        href={`/packageDetail/${exam._id}`}
                                        myLibExam={info.myLibExam}
                                        isInMylib={this.isInMylib(exam._id, this.typeOfProduct(exam))}
                                        typeOfProduct={this.typeOfProduct(exam)}
                                      />
                                    ))
                                    : ''
                                  }
                                </ul>
                              </div>
                            </div> : ''
                            }
                            { newExam.length !== 0 ?
                            <div>
                              <Row gutter={32} justify="space-around">
                                <Col span={12}>
                                  <h3>ข้อสอบมาใหม่</h3>
                                </Col>
                                <Col span={12}>
                                  <button className="seeAll" onClick={() => showAll(2)}>ดูทั้งหมด</button>
                                </Col>
                              </Row>
                              <hr />
                              <div id="examProductPanel_2" className="examProductPanel" style={{ height: newExam.length < 4 ? '397.5px' : '795px' }}>
                                <ul className="products">
                                  {
                                    newExam.length !== 0 ?
                                    newExam.map((exam, index) => (
                                      <_cardExamProduct
                                        key={index}
                                        imgURL={exam.promotional.imageURL_1_1}
                                        productName={exam.productName}
                                        coin={exam.coinPriceDate ? exam.coinPriceDate : []}
                                        numQuestion={exam.exams.numQuestion}
                                        rating={exam.rating.avg}
                                        userrating={exam.rating.user}
                                        href={`/eTestingOverview/${exam._id}`}
                                        myLibExam={info.myLibExam}
                                        isInMylib={this.isInMylib(exam._id, this.typeOfProduct(exam))}
                                      />
                                    ))
                                    : ''
                                  }
                                </ul>
                              </div>
                            </div> : ''
                            }
                            {/* <Row gutter={32} justify="space-around">
                              <Col span={12}>
                                <h3>คอร์สแนะนำ</h3>
                              </Col>
                              <Col span={12}>
                                <button className="seeAll" onClick={() => showAll(1)}>ดูทั้งหมด</button>
                              </Col>
                            </Row>
                            <hr />
                            <div id="examProductPanel_1" className="examProductPanel">
                              <ul className="products">
                                {
                                  pages.coursesRecommended.length !== 0 ?
                                    pages.coursesRecommended.map((course, index) => (
                                      <_cardProduct
                                        key={index}
                                        imgURL={course.promotional.imageURL_16_9}
                                        videoLength={this.spendTime(course.courses.videoLength)}
                                        productName={course.productName}
                                        uploader={course.uploaders[0].displayName}
                                        coin={course.coin}
                                        productDescription={''}
                                        rating={course.rating.avg}
                                        userrating={course.rating.user}
                                        href={`/course/${course._id}`}
                                      />
                                    ))
                                    : ''
                                }
                              </ul>
                            </div> */}
                            {popularExam.length !== 0 ?
                            <div>
                            <Row gutter={32} justify="space-around">
                              <Col span={12}>
                                <h3>ข้อสอบยอดนิยม</h3>
                              </Col>
                              <Col span={12}>
                                <button className="seeAll" onClick={() => showAll(3)}>ดูทั้งหมด</button>
                              </Col>
                            </Row>
                            <hr />
                            <div id="examProductPanel_3" className="examProductPanel" style={{ height: popularExam.length < 4 ? '397.5px' : '795px' }}>
                              <ul className="products">
                                {
                                  popularExam.length !== 0 ?
                                  popularExam.map((course, index) => (
                                    <_cardExamProduct
                                      key={index}
                                      imgURL={course.promotional.imageURL_1_1}
                                      productName={course.productName}
                                      coin={course.coinPriceDate ? course.coinPriceDate : []}
                                      numQuestion={course.exams.numQuestion}
                                      rating={course.rating.avg}
                                      userrating={course.rating.user}
                                      href={`/eTestingOverview/${course._id}`}
                                      myLibExam={info.myLibExam}
                                      isInMylib={this.isInMylib(course._id, this.typeOfProduct(course))}
                                    />
                                  ))
                                  : ''
                                }
                              </ul>
                            </div>
                            </div>: ''
                            }
                            {/* <SubBanner /> */}
                            { allExam.length !== 0 ?
                            <div>
                            <Row gutter={32} justify="space-around">
                              <Col span={12}>
                                <h3>ข้อสอบทั้งหมด</h3>
                              </Col>
                              <Col span={12}>
                                <button className="seeAll" onClick={() => showAll(4)}>ดูทั้งหมด</button>
                              </Col>
                            </Row>
                            <hr />
                            <div id="examProductPanel_4" className="examProductPanel"  style={{ height: allExam.length < 4 ? '397.5px' : '795px' }}>
                              <ul className="products">
                                {
                                 allExam.length !== 0 ?
                                 allExam.map((course, index) => (
                                   <_cardExamProduct
                                     key={index}
                                     imgURL={course.promotional.imageURL_1_1}
                                     productName={course.productName}
                                     coin={course.coinPriceDate ? course.coinPriceDate : []}
                                     numQuestion={course.exams.numQuestion}
                                     rating={course.rating.avg}
                                     userrating={course.rating.user}
                                     href={`/eTestingOverview/${course._id}`}
                                     myLibExam={info.myLibExam}
                                     isInMylib={this.isInMylib(course._id, this.typeOfProduct(course))}
                                   />
                                 ))
                                 : <div className="container-404">
                                   <h>ยังไม่มีคอร์สเรียน</h>
                                 </div>
                                }
                              </ul>
                            </div>
                            </div> : ''
                            }
                          </div>
                      }
                    </div>
                    :
                    <div id="courseSection">
                      {/* <div id="examProductPanel_4" className="etcproductsPanel examProductPanel selectproductsPanel "> */}
                      {listExam.exam.length > 0 ?
                      <div >
                        {/* <h3>{this.name}</h3>
                        <hr /> */}
                        <Row gutter={32} justify="space-around">
                          <Col span={12}>
                            <h3>{this.name}</h3>
                          </Col>
                          <Col span={12}>
                            {/* <button className="seeAll" onClick={() => showAll(4)}>ดูทั้งหมด</button> */}
                          </Col>
                        </Row>
                        <hr />
                        {
                          listExam.exam.length !== 0 ?
                            <ul className="products">
                              {
                                listExam.exam.map((course, index) => (
                                  <_cardExamProduct
                                    key={index}
                                    imgURL={course.promotional.imageURL_1_1}
                                    productName={course.productName}
                                    coin={course.coinPriceDate ? course.coinPriceDate : []}
                                    numQuestion={course.exams.numQuestion}
                                    rating={course.rating.avg}
                                    userrating={course.rating.user}
                                    href={`/eTestingOverview/${course._id}`}
                                    myLibExam={info.myLibExam}
                                    isInMylib={this.isInMylib(course._id, this.typeOfProduct(course))}
                                  />
                                ))
                              }
                            </ul>
                            : <div className="container-404">
                              <h>ยังไม่มีคอร์สเรียน</h>
                            </div>
                        }
                      </div>: <div className="container-404">
                              <Icon type="file-text" style={{ fontSize: '70pt', color: '#D8D8D8', marginBottom: 10 }} />
                              <p style={{ fontSize: 20 }}>
                                ไม่พบสินค้าในหมวดหมู่ที่คุณต้องการ
                              </p>
                            </div>
                      }
                    </div>
                }
                <br />
                { screen === EXTRA_SMALL_DEVICE ?
                  <div className="fb-page"
                    style={{ textAlign: 'center' }}
                    data-href="https://www.facebook.com/deknerdclub/"
                    data-tabs="timeline,messages"
                    data-small-header="false"
                    data-adapt-container-width="true"
                    data-hide-cover="false"
                    data-show-facepile="true"
                  >
                    <blockquote cite="https://www.facebook.com/deknerdclub/"
                      className="fb-xfbml-parse-ignore"
                    >
                      <a href="https://www.facebook.com/deknerdclub/">DekNerd-เด็กเนิร์ด</a></blockquote></div>
                      : ''
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default etestingHome



// WEBPACK FOOTER //
// ./src/components/pages/eTestingHome.js